import { ApplicationV1Enum } from "@/api-schema-enums";
import { useApplicationCreateMutation } from "@/common/api/application/use-application-create.mutation";
import { toastMutationStatus } from "@/common/helpers/toast-mutation-status";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { Card, CardContent } from "@/components/ui/card";
import { Form } from "@/components/ui/form";
import { FormCardActions } from "@/components/ui/form-card";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation } from "wouter";
import { ApplicationFormFields, formSchema, formSchemaType } from "./_components/application-form-fields";

export function ApplicationCreateView() {
  const { t } = useTranslation(["ram", "common"]);
  const pageTitle = t("ram:CreateApp");
  const pageSubtitle = t("common:CompleteRequiredInformationDescription");
  const [_, navigate] = useLocation();
  const { mutateAsync, isPending } = useApplicationCreateMutation();

  const form = useForm<formSchemaType>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      azureClientUuid: "",
      isV1Application: ApplicationV1Enum.IsNotV1,
    },
  });

  const onSubmit = async (values: formSchemaType) => {
    await toastMutationStatus({
      mutationFn: () => mutateAsync(values),
      successMessage: t("ram:AppHasBeenAdded"),
      errorMessage: t("ram:ErrorInCreatingTheApp"),
    });

    navigate("/");
  };

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
          <Card>
            <CardContent className="space-y-6">
              <ApplicationFormFields formControl={form.control} />
            </CardContent>
          </Card>

          <FormCardActions
            cancelLabel={t("common:Cancel")}
            onCancel={() => navigate("/")}
            isPending={isPending}
            submitLabel={t("common:Save")}
          />
        </form>
      </Form>
    </CenteredLayout>
  );
}
